import type { CreateGatewayCard } from '../../customer-cards/dto/create-customer-card.dto'
import type { PurchaseType } from '../purchase.enum'
import type { CreateGatewayCustomer } from './create-customer.dto'

export class GatewayCustomerCard {
    cardId?: string
    number?: string
    name?: string
    expirationMonth?: string
    expirationYear?: string
    securityCode?: string
    brand?: string
}

export class CreateInvoiceDto {
    gatewayId: string
    purchaseDescription: string
    purchaseQuantity?: number // a quantidade de itens comprados. não interfere no cáculo de valores e parcelas. (apenas para fim de cálculo de MRR).
    purchaseTotalValue: number // se 'recurring_continuous' este valor é cobrado todo período. caso contrário é dividido por 'purchaseTotalInstallment'
    purchaseTotalInstallments?: number // apenas se type !== 'recurring_continuous'
    // entrada do carnê: o primeiro vencimento vale isto e os demais dividem o que sobra. a entrada é
    // o vencimento #1 de N, não um a mais — 'entrada + 5 parcelas' na tela é N = 6 aqui.
    purchaseEntryValue?: number // apenas se type === 'recurring_fixed'
    purchaseFirstCharge: Date
    purchaseType: PurchaseType
    card: CreateGatewayCard // se InvoiceCustomer já existir, continua sem erros aproveitando o ID já existente
    customer: CreateGatewayCustomer
    gatewayCustomerCardId?: string
    referenceId?: string // não é único. pode ser usado o id de um cliente, por exemplo
    uniqueId?: string // id único enviado pelo cliente. não permite duplicidade.
    purchaseLaunchType?: string
    purchaseServiceId?: string
    purchaseUserId?: string
    purchasePaymentId?: string
    purchaseMethod?: string
}
